import { api, buildQueryParams, FilterOptionsResponse } from "../index";
import { Invitations } from "../invitations/dto/invitations.dto";
import {
	AffiliateCreateDTO,
	SettlementDTO,
	SettlementStatusEnum,
	IAdminDashboardStatsResponse,
	IAdminFilterOptions,
	AdminAffiliateStatsResponse
} from "../affiliate/dto/affiliate.dto";

const WEDDING_INVITATION_ENDPOINT_ADMIN = "/admin";

export const adminAPI = api.injectEndpoints({
	endpoints: build => ({
		getAdminWeddingInvitations: build.query<FilterOptionsResponse<Invitations[]>, IAdminFilterOptions>({
			query: ({ page, perPage, sortBy, status }) => ({
				url: `${WEDDING_INVITATION_ENDPOINT_ADMIN}/invitations-list${buildQueryParams({ page, perPage, sortBy, status })}`,
				method: "GET"
			}),
			providesTags: ["getAdminWeddingInvitations"]
		}),
		useGetAdminDashboardStats: build.query<IAdminDashboardStatsResponse, {}>({
			query: () => ({
				url: `${WEDDING_INVITATION_ENDPOINT_ADMIN}/dashboard/stats`,
				method: "GET"
			}),
			providesTags: []
		}),
		publishWeddingInvitation: build.mutation<{ success: boolean }, { id: string }>({
			query: ({ id }) => ({
				url: `${WEDDING_INVITATION_ENDPOINT_ADMIN}/publish-invitation/${id}`,
				method: "PUT"
			}),
			invalidatesTags: ["getAdminWeddingInvitations"]
		}),
		unPublishWeddingInvitation: build.mutation<{ success: boolean }, { id: string }>({
			query: ({ id }) => ({
				url: `${WEDDING_INVITATION_ENDPOINT_ADMIN}/unPublish-invitation/${id}`,
				method: "PUT"
			}),
			invalidatesTags: ["getAdminWeddingInvitations"]
		}),
		rejectWeddingInvitation: build.mutation<{ success: boolean }, { id: string }>({
			query: ({ id }) => ({
				url: `${WEDDING_INVITATION_ENDPOINT_ADMIN}/reject-publish/${id}`,
				method: "PUT"
			}),
			invalidatesTags: ["getAdminWeddingInvitations"]
		}),
		actionRequiredWeddingInvitation: build.mutation<{ success: boolean }, { id: string }>({
			query: ({ id }) => ({
				url: `${WEDDING_INVITATION_ENDPOINT_ADMIN}/action-required/${id}`,
				method: "PUT"
			}),
			invalidatesTags: ["getAdminWeddingInvitations"]
		}),
		suspendWeddingInvitation: build.mutation<{ success: boolean }, { id: string }>({
			query: ({ id }) => ({
				url: `${WEDDING_INVITATION_ENDPOINT_ADMIN}/suspend-invitation/${id}`,
				method: "PUT"
			}),
			invalidatesTags: ["getAdminWeddingInvitations"]
		}),
		getAffiliateUsers: build.query<FilterOptionsResponse<AffiliateCreateDTO[]>, { page: number; perPage: number }>({
			query: ({ page, perPage }) => ({
				url: `${WEDDING_INVITATION_ENDPOINT_ADMIN}/affiliates`,
				params: { page, perPage },
				method: "GET"
			}),
			providesTags: ["adminAffiliateUsers"]
		}),
		updateAffiliateCouponStatus: build.mutation<
			{ coupon: AffiliateCreateDTO },
			{ user_id: string; code: string; status: number }
		>({
			query: body => ({
				url: `${WEDDING_INVITATION_ENDPOINT_ADMIN}/coupon-status`,
				method: "PUT",
				body
			}),
			invalidatesTags: ["adminAffiliateUsers"]
		}),
		getSettlements: build.query<
			FilterOptionsResponse<SettlementDTO[]>,
			{ month: string; page: number; perPage: number }
		>({
			query: ({ month, page, perPage }) => ({
				url: `${WEDDING_INVITATION_ENDPOINT_ADMIN}/settlements`,
				method: "GET",
				params: { month, page, perPage }
			}),
			providesTags: ["adminSettlements"]
		}),
		updateSettlementStatus: build.mutation<{ success: boolean }, { id: string; status: SettlementStatusEnum }>({
			query: body => ({
				url: `${WEDDING_INVITATION_ENDPOINT_ADMIN}/settlement-status`,
				method: "PUT",
				body
			}),
			invalidatesTags: ["adminSettlements"]
		}),
		getAffiliateStats: build.query<AdminAffiliateStatsResponse, {}>({
			query: () => ({
				url: `${WEDDING_INVITATION_ENDPOINT_ADMIN}/affiliates/stats`,
				method: "GET"
			}),
			providesTags: ["adminAffiliateStats"]
		})
	})
});

export const {
	useUseGetAdminDashboardStatsQuery,
	useLazyGetAdminWeddingInvitationsQuery,
	usePublishWeddingInvitationMutation,
	useUnPublishWeddingInvitationMutation,
	useRejectWeddingInvitationMutation,
	useActionRequiredWeddingInvitationMutation,
	useSuspendWeddingInvitationMutation,
	useLazyGetAffiliateUsersQuery,
	useUpdateAffiliateCouponStatusMutation,
	useLazyGetSettlementsQuery,
	useUpdateSettlementStatusMutation,
	useGetAffiliateStatsQuery
} = adminAPI;
